export default {
  meetingInfo: {
    webinarId: "",
    weChatId: "",
    instanceId: "",
    schemaId: "",
    webcastId: "",
    pcConfigId: "", // 2451446
    wapConfigId: "", // 2451447
    registrationFormId: "",
    shortUrl: "",
    unLimitUrl: "",
    hlsUrl: "",
    rtmpUrl: "",
    endTimeOffset: "",
    startTimeOffset: 60,
    title: "一站式 “营销自动化SAAS平台+营销应用服务” 解决方案大会",
    intro:
      "赛诺贝斯®（北京）营销技术股份有限公司（简称：赛诺贝斯®）是国内营销领域领先的营销自动化服务商，为客户提供基于自主开发的自动化营销SAAS产品 帮助客户完成营销全过程的自动化管理；同时提供基于平台产品延伸的营销服务包括：数字营销、精准营销、大数据应用。为多个行业客户，实现整合、高效、一站式的“营销自动化SAAS平台+营销应用服务” 解决方案。通过十余年的发展成为戴尔中国，富士施乐，赛门铁克，甲骨文，东风标致、联想、百度等众多世界500强和国内众多知名企业的长期营销产品及服务的供应商。\n",
    customPage: "",
    adList: [
      {
        adContent: "这里也可以放文本广告 ",
        adId: 16,
        adPic: require("../assets/images/moren-guanggao.jpg"),
        adTitle: "",
        adType: 1,
        adUrl: "",
        tenantId: 1038,
        webinarId: 41868
      },
      {
        adContent: "这里也可以放文本广告 ",
        adId: 14,
        adPic: require("../assets/images/moren-guanggao.jpg"),
        adTitle: "",
        adType: 2,
        adUrl: "",
        tenantId: 1038,
        webinarId: 41868
      }
    ],
    sponsor: "这里是主办方",
    logo: "",
    logoRealPath: "",
    startTime: 1597107600000,
    endTime: 1597157940000,
    mainScreen: "",
    status: 3,
    videoStatus: "",
    needLogin: "",
    isSilent: "",
    isClosed: "",
    isReleased: "",
    unLimit: "",
    needRegistration: "",
    isOpen: true,
    isOnDemand: undefined,
    demandInfoUrl: undefined,
    demandUrl: undefined,
    globalUserId: "",
    storageKey: undefined,
    isSetUserName: false,
    isAllowMessage: false,
    shareSummary: "",
    webCastProvider: "",
    folderId: "",
    guestList: [
      {
        department: "",
        duty: "",
        email: null,
        enterprise: "",
        gender: 1,
        guestId: 2206,
        guestTypeId: 291,
        headImgUrl: require("../assets/images/moren-jiabin.jpg"),
        intro: "O&O数字会议解决方案专家",
        mobile: null,
        name: "赛诺贝斯",
        webinarGuestId: 12358
      },
      {
        department: "",
        duty: "",
        email: null,
        enterprise: "",
        gender: 1,
        guestId: 2206,
        guestTypeId: 291,
        headImgUrl: require("../assets/images/moren-jiabin.jpg"),
        intro: "微信营销解决方案专家",
        mobile: null,
        name: "SINObase",
        webinarGuestId: 12358
      },
      {
        department: "",
        duty: "",
        email: null,
        enterprise: "",
        gender: 1,
        guestId: 2206,
        guestTypeId: 291,
        headImgUrl: require("../assets/images/moren-jiabin.jpg"),
        intro: "营销自动化解决方案专家",
        mobile: null,
        name: "赛诺",
        webinarGuestId: 12358
      }
    ],
    agendaList: [
      {
        agendaGuest: [
          {
            guestType: "演讲嘉宾",
            name: "赛诺贝斯",
            webinarGuestId: 12358
          }
        ],
        agendaId: 7263,
        endTime: 1579438800,
        resources: [1326280],
        startTime: 1579435200,
        theme: "O&O数字会议解决方案"
      },
      {
        agendaGuest: [
          {
            guestType: "演讲嘉宾",
            name: "SINObase ",
            webinarGuestId: 12358
          }
        ],
        agendaId: 7263,
        endTime: 1579440600,
        resources: [1326280],
        startTime: 1579438800,
        theme: "微信营销解决方案"
      },
      {
        agendaGuest: [
          {
            guestType: "演讲嘉宾",
            name: "赛诺",
            webinarGuestId: 12358
          }
        ],
        agendaId: 7263,
        endTime: 1579444200,
        resources: [1326280],
        startTime: 1579440600,
        theme: "营销自动化解决方案"
      }
    ]
  },
  recommendList: [
    {
      id: 1,
      title: "推荐会议",
      pic: require("../assets/images/moren-tuijian.jpg"),
      url: "www.baidu.com",
      tags: ""
    },
    {
      id: 2,
      title: "推荐会议",
      pic: require("../assets/images/moren-tuijian.jpg"),
      url: "www.baidu.com",
      tags: ""
    },
    {
      id: 3,
      title: "推荐会议",
      pic: require("../assets/images/moren-tuijian.jpg"),
      url: "www.baidu.com",
      tags: ""
    }
  ],
  userInfo: {},
  pcPackBackVideoList: [
    {
      id: 0,
      img: require("../assets/images/pc@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    },
    {
      id: 1,
      img: require("../assets/images/pc@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    },
    {
      id: 2,
      img: require("../assets/images/pc@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    }
  ],
  wapPackBackVideoList: [
    {
      id: 0,
      img: require("../assets/images/wap@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    },
    {
      id: 1,
      img: require("../assets/images/wap@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    },
    {
      id: 2,
      img: require("../assets/images/wap@2x.png"),
      title: "秉承「以终为始」，决胜B2B企业营销路径最后一英里。"
    }
  ]
};
